import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { PageHeaderComponent } from './page-header.component';

export const imports: NgModule['imports'] = [FlexLayoutModule];

@NgModule({
  declarations: [PageHeaderComponent],
  imports: [...imports, CommonModule],
  exports: [PageHeaderComponent],
})
export class PageHeaderModule {}
